var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MyAddressList',{ref:"address",attrs:{"type":"1","uuid":_vm.uuid,"show-id":_vm.showId},on:{"set":_vm.setAddress,"close":_vm.close}})}
var staticRenderFns = []

export { render, staticRenderFns }